// Mock data for XÆRA website

export const albumData = {
  title: "BECOMING CONSCIOUS",
  stylizedTitle: "II",
  image: "https://customer-assets.emergentagent.com/job_xaera-web/artifacts/1qjh7f2h_bc%20eyes%20render-moshed-08-30-23-00-35.png",
  listenUrl: "/listen",
  vinylUrl: "https://elasticstage.com/bec0ming-c0nsci0us/releases/becoming-conscious-album",
  merchUrl: "https://becoming-conscious-merch.myshopify.com/?pb=0"
};

export const streamingLinks = [
  {
    name: "Spotify",
    url: "https://open.spotify.com/album/5wpDTkhVApq8qpYnyfPeXa?si=1&nd=1&dlsi=9368408558d340f0",
    icon: "Music"
  },
  {
    name: "Apple Music",
    url: "https://music.apple.com/ch/album/becoming-conscious/1812922136",
    icon: "Music"
  },
  {
    name: "Deezer",
    url: "https://www.deezer.com/en/album/753289571",
    icon: "Music"
  },
  {
    name: "Tidal",
    url: "https://tidal.com/album/434449934",
    icon: "Music"
  },
  {
    name: "Beatport",
    url: "https://www.beatport.com/release/becoming-conscious/5075505",
    icon: "Music"
  }
];

export const tourDates = [
  {
    id: 1,
    date: "2025-02-15",
    venue: "The Echo",
    city: "Los Angeles, CA",
    ticketUrl: "#"
  },
  {
    id: 2,
    date: "2025-03-01",
    venue: "Brooklyn Steel",
    city: "Brooklyn, NY",
    ticketUrl: "#"
  },
  {
    id: 3,
    date: "2025-03-20",
    venue: "The Midway",
    city: "San Francisco, CA",
    ticketUrl: "#"
  }
];

export const merchItems = [
  {
    id: 1,
    name: "BECOMING CONSCIOUS Vinyl",
    price: "$35.00",
    image: "https://images.unsplash.com/photo-1489509712485-388eeb625c6e?w=400&h=400&fit=crop",
    url: "https://becoming-conscious-merch.myshopify.com/?pb=0"
  },
  {
    id: 2,
    name: "XÆRA T-Shirt",
    price: "$25.00",
    image: "https://images.unsplash.com/photo-1583743814966-8936f5b7be1a?w=400&h=400&fit=crop",
    url: "https://becoming-conscious-merch.myshopify.com/?pb=0"
  },
  {
    id: 3,
    name: "Limited Edition Poster",
    price: "$15.00",
    image: "https://images.unsplash.com/photo-1611329532992-0b7d7d00b0f2?w=400&h=400&fit=crop",
    url: "https://becoming-conscious-merch.myshopify.com/?pb=0"
  }
];

export const socialLinks = [
  { name: "Spotify", url: "https://spotify.com", icon: "Music" },
  { name: "Instagram", url: "https://instagram.com", icon: "Instagram" },
  { name: "Twitter", url: "https://twitter.com", icon: "Twitter" },
  { name: "YouTube", url: "https://youtube.com", icon: "Youtube" },
  { name: "SoundCloud", url: "https://soundcloud.com", icon: "Cloud" }
];

export const masteringInfo = {
  title: "MASTERING SERVICES",
  description: "Professional audio mastering for your tracks. Bringing clarity, depth, and power to your music.",
  services: [
    "Stem Mastering",
    "Stereo Mastering"
  ],
  email: "mastering@xaera.com"
};
